// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._38ztG-bhSdhfSR {\n  margin: 16px 0 12px 56px;\n  min-height: 32px;\n  position: relative;\n  z-index: 1;\n}\n._1Vi1sNt2LIRugj {\n  left: -36px;\n  position: absolute;\n}\n._1aI1wfr1OLDpgC {\n  color: #172B4D;\n  font-size: 20px;\n  font-weight: 600;\n  letter-spacing: -0.008em;\n  line-height: 24px;\n  margin-top: 28px;\n  margin: 0;\n  overflow-wrap: break-word;\n}\n._6lzMtJa-CvSFtX {\n  color: #5E6C84;\n  cursor: default;\n  display: inline-block;\n  margin: 4px 12px 0 0;\n}\n._1E-u9MqdzxgzKQ {\n  color: #5E6C84;\n}\n._1dzS1A8Mvc6ibv {\n  display: inline-block;\n  vertical-align: middle;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": "_38ztG-bhSdhfSR",
	"cardIcon": "_1Vi1sNt2LIRugj",
	"cardName": "_1aI1wfr1OLDpgC",
	"cardLocation": "_6lzMtJa-CvSFtX",
	"boardLink": "_1E-u9MqdzxgzKQ",
	"subscribedIndicator": "_1dzS1A8Mvc6ibv"
};
export default ___CSS_LOADER_EXPORT___;
